<template>
  <Modal
    title="Edit Steps"
    :max-width="800"
    body-overflow="auto"
    body-max-height="70vh"
    @close="$emit('close')"
  >
    <SequenceEditorForm
      ref="editorRef"
      :initial-name="initialName"
      :initial-description="initialDescription"
      :initial-steps="initialSteps"
      :step-types="stepTypes"
      :locked="locked"
      :save-error="saveError"
    />

    <template #footer>
      <button class="btn secondary" @click="$emit('close')">Cancel</button>
      <button class="btn primary" @click="onSave">Apply</button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Modal from '../../components/Modal.vue'
import SequenceEditorForm from '../../components/SequenceEditorForm.vue'

const props = defineProps<{
  sequenceId?: string | null
  initialName?: string
  initialDescription?: string
  initialSteps?: any[]
  locked?: boolean
  stepTypes?: string[] | null
}>()

const emit = defineEmits<{
  close: []
  saved: [sequence: any]
}>()

const editorRef = ref<InstanceType<typeof SequenceEditorForm> | null>(null)
const saveError = ref('')

function onSave() {
  const form = editorRef.value?.form
  if (!form) return

  for (const [i, s] of form.steps.entries()) {
    if (s.step_type === 'wait' && (!s.wait_days || s.wait_days < 1)) {
      saveError.value = `Step ${i + 1}: wait amount must be at least 1`
      return
    }
  }

  saveError.value = ''
  emit('saved', {
    id: props.sequenceId || null,
    name: form.name.trim(),
    description: form.description.trim() || null,
    steps: form.steps.map((s: any) => ({
      step_index: s.step_index,
      step_type: s.step_type,
      brief: s.step_type !== 'wait' ? (s.brief?.trim() || null) : null,
      wait_days: s.step_type === 'wait' ? (s.wait_days || 3) : null,
      wait_unit: s.step_type === 'wait' ? (s.wait_unit || 'days') : null,
    })),
  })
}
</script>
